import { render, staticRenderFns } from "./DetalleMuestra.vue?vue&type=template&id=704bd4aa&"
import script from "./DetalleMuestra.vue?vue&type=script&lang=js&"
export * from "./DetalleMuestra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports